import React from 'react';
import { SpecsPanel } from '@marvelapp/ui-internal';
import ElementAssets from '../../../containers/handoff/sidebar/ElementAssets';
export default function SelectedElementAssets(_a) {
    var element = _a.element;
    return (React.createElement(SpecsPanel, { title: "Assets" },
        React.createElement(ElementAssets, { element: element })));
}
